import { Tabs } from "antd";
import { useState } from "react";
import { CloudUploadOutlined } from "@ant-design/icons";

import HeaderPage from "../HeaderPage";
import Sidebar from "../Sidebar";

import "./styles.css";
import { UploadContratosTab } from "./TabsContents/UploadContratosTab";

function UploadContratos() {
  const [activeKey, setActiveKey] = useState<string>("1");
  const TAB_CONFIG = [
    {
      key: "1",
      label: "Freight contract",
      icon: <CloudUploadOutlined />,
      content: <UploadContratosTab />,
    },
  ];

  return (
    <div className="flex-dashboard">
      <Sidebar elementoAtivo="uploadContratos" />
      <main>
        <HeaderPage nomeOpcao="Upload de Contratos" />

        <div className="main-content">
          <Tabs
            activeKey={activeKey}
            onChange={setActiveKey}
            type="card"
            tabBarGutter={8}
            moreIcon={null}
          >
            {TAB_CONFIG.map((tab) => (
              <Tabs.TabPane
                key={tab.key}
                tab={
                  <span className="flex items-center gap-2">
                    {tab.icon}
                    {tab.label}
                  </span>
                }
              >
                {tab.content}
              </Tabs.TabPane>
            ))}
          </Tabs>
        </div>
      </main>
    </div>
  );
}

export default UploadContratos;
